interface Route {
  fullPath: string
}

export const update = (to?: Route) => {
  window.preventSentryLogging = true
  try {
    sessionStorage.setItem('__reload_source', 'reload-util')
  } catch {}

  if (to) {
    window.location.href = to.fullPath
  } else {
    window.location.reload()
  }
}
